import React from "react";
import PropTypes from "prop-types";
import { Title } from "rbx";
import { WorkOrderLaborItem } from "../../../../components/WorkOrders";
import { useAuthorization } from "../../../../components/Authorization";

function Labor({
  removeRow,
  handleChange,
  Items,
  WorkOrder,
  loading,
  companySettings
}) {
  const AdminAuth = useAuthorization(["ADMIN"]);
  const FleetAuth = useAuthorization(["FLEET"]);
  return (
    <React.Fragment>
      {Items && Items.length > 0 ? (
        Items.map((item, i) => (
          <WorkOrderLaborItem
            Auth={!!(AdminAuth || FleetAuth)}
            WorkOrder={WorkOrder}
            companySettings={companySettings}
            disabled={loading || WorkOrder.LaborApproved}
            handleChange={handleChange(i)}
            item={item}
            key={item.RecId}
            removeRow={() => removeRow(i, item)}
          />
        ))
      ) : (
        <Title subtitle>No Labor Added</Title>
      )}
    </React.Fragment>
  );
}

Labor.propTypes = {
  removeRow: PropTypes.func,
  handleChange: PropTypes.func,
  Items: PropTypes.array,
  WorkOrder: PropTypes.object,
  loading: PropTypes.bool,
  companySettings: PropTypes.object
};
export default Labor;
